export { default as suitz } from './suitz.jpg';
export { default as suitsCard } from './suitsCard.jpg';
export { default as coffeeFindr } from './coffeeFindr.jpg';



// WEBPACK FOOTER //
// ./src/img/index.js